import { useState } from 'react';
import { Box, Button, Input, Typography, Card, Alert } from '@mui/joy';
import LockIcon from '@mui/icons-material/Lock';

const CORRECT_PASSWORD = 'admin123';

function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      localStorage.setItem('admin_password', password);
      onLogin();
    } else {
      setError(true);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Card variant="outlined" sx={{ p: 4, minWidth: 360, borderRadius: 20 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <Box sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: 'primary.softBg',
            color: 'primary.plainColor',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
          }}>
            <LockIcon sx={{ fontSize: 28 }} />
          </Box>
          <Typography level="h4" textAlign="center">Вход в админку</Typography>
          <Typography level="body-sm" textColor="neutral.500" textAlign="center">Введите пароль для продолжения</Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <Input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(false); }}
            sx={{ mb: 2 }}
          />
          {error && (
            <Alert color="danger" sx={{ mb: 2 }}>
              Неверный пароль
            </Alert>
          )}
          <Button type="submit" fullWidth>Войти</Button>
        </form>
      </Card>
    </Box>
  );
}

export default AdminLogin;
